module.exports = __webpack_public_path__ + "img/download.1df60300.svg";